const api = [{
  name: 'list',
  method: 'GET',
  path: '/list',
  desc: '获取功能列表',
  mock: false,
  params: {
    pageNum: 1,
    pageSize: 25
  }
},
{
  name: 'addFunction',
  method: 'POST',
  path: '/addFunction',
  desc: '添加功能',
  mock: false,
  params: {}
},
{
  name: 'checkFunctionName',
  method: 'GET',
  path: '/checkFunctionName',
  desc: '检测功能名称是否存在',
  mock: false,
  params: {}
},
{
  name: 'checkFunCode',
  method: 'GET',
  path: '/checkFunCode',
  desc: '检测功能编码是否存在',
  mock: false,
  params: {}
},
{
  name: 'getLevel1Menu',
  method: 'GET',
  path: '/getLevel1Menu',
  desc: '加载菜单',
  mock: false,
  params: {}
},
{
  name: 'getSysFunction',
  method: 'GET',
  path: '/getSysFunction',
  desc: '编辑功能',
  mock: false,
  params: {}
},
{
  name: 'openFunction',
  method: 'POST',
  path: '/openFunction',
  desc: '开启/停用功能',
  mock: false,
  params: {}
},
{
  name: 'updateFunction',
  method: 'POST',
  path: '/updateFunction',
  desc: '更新功能',
  mock: false,
  params: {}
},
{
  name: 'deleteFunction',
  method: 'GET',
  path: '/deleteFunction',
  append: true,
  desc: '删除功能',
  mock: false,
  params: {}
},
{
  name: 'getFunTypes',
  method: 'GET',
  path: '/getFunTypes',
  desc: '获得功能类型列表',
  mock: false,
  params: {}
}
]

export default {
  BASE_URL: '/sysFunction',
  NAMESPACE: 'function',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/sys/function.js